import { atom } from "recoil";

import { generateRandomId } from "../utils/browser";

import { StateKeys } from "./StateKeys";

// TODO - Move this file closer to where its used

export const sessionIdAtom = atom<string>({
    key: StateKeys.SessionId,
    default: generateRandomId(),
});

export const blizzardInitializedAtom = atom({
    key: StateKeys.BlizzardInitialized,
    default: false,
});
